<template>
  <div>
    <div class="card is-smallshadow">
      <div class="card-body py-3">
        <h2 class="heading-small text-grey mb-2">
          {{ $t('adviserSettings.education') }}
        </h2>

        <div v-if="loadedEducations">
          <div
            v-for="(education, index) of allEducations"
            :key="'education-' + index"
            :class="{
              'flex flex-align-items-center items-list items-list-bigger': true,
              'mt-2 pb-2 full-width': true,
              'border-bottom': index < allEducations.length - 1
            }">
            <div class="item-index pr-1">
              <strong>{{ index + 1 }}.</strong>
            </div>
            <div class="item-data mr-2">
              <small>{{ $t('adviserSettingsEducationInfo.fieldOfStudy') }} </small><br>
              <strong class="text-primary">{{ education.study_field }}</strong>
            </div>
            <div class="item-data mr-2">
              <small>{{ $t('adviserSettingsEducationInfo.university') }} </small><br>
              <strong class="text-primary">{{ education.school_name }}</strong>
            </div>
            <div class="item-data mr-2">
              <small>{{ $t('adviserSettingsEducationInfo.timeStart') }} </small><br>
              <strong class="text-primary">{{ education.start_at }}</strong>
            </div>
            <div class="item-data">
              <small>{{ $t('adviserSettingsEducationInfo.timeEnd') }} </small><br>
              <strong class="text-primary">
                <template v-if="education.end_at">
                  {{ education.end_at }}
                </template>
                <template v-else>
                  -
                </template>
              </strong>
            </div>
            <div class="item-options ml-2">
              <f-dropdown
                theme="minimal"
                type="more"
                :items="[
                  {
                    type: 'button',
                    disabled: false,
                    event: 'adviser-education-edit',
                    param: education,
                    label: $t('ui.edit'),
                    name: 'edit'
                  },
                  {
                    type: 'button',
                    disabled: false,
                    event: 'adviser-education-remove',
                    param: education,
                    label:  $t('ui.remove'),
                    theme: 'danger',
                    name: 'delete'
                  }
                ]"/>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer pt-3 pb-4 text-right">
        <f-button
          v-if="loadedEducations"
          theme="primary"
          big
          @click.prevent="$bus.$emit('adviser-education-popup-show')">
          {{ $t('adviserSettingsEducationInfo.addEntry') }}
        </f-button>
      </div>
    </div>

    <div
      v-if="!loadedEducations && !loadError"
      class="loading-spinner-wrapper">
      <div class="loading-spinner pb-3 pt-3">
        <span class="loading-spinner-content">
          {{ $t('ui.loadingDataInProgress') }}&hellip;
        </span>
      </div>
    </div>
    <f-alert
      v-if="loadError"
      visible
      theme="warning">
      <span>
        {{ $t('ui.dataLoadError.dataErrorMess') }} <a href="javascript:window.location.reload();" class="lnk lnk-alert">{{ $t('ui.dataLoadError.resetPageButton') }}</a> {{ $t('ui.dataLoadError.forTryAgain') }}
      </span>
    </f-alert>

    <adviser-education-popup />
  </div>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import ListUtils from '@/utils/ListUtils.js';
import AdviserEducationPopup from '@/components/popups/AdviserEducationPopup.vue';

export default {
  name: 'adviser-settings-education-info',
  components: {
    'adviser-education-popup': AdviserEducationPopup
  },
  data() {
    return {
      allEducations: [],
      loadedEducations: false,
      removeInProgress: false,
      loadError: false
    }
  },
  mounted() {
    this.$bus.$on('adviser-education-edit', this.editEducation);
    this.$bus.$on('adviser-education-remove', this.removeEducation);
    this.$bus.$on('advisor-education-reload', this.loadItemData);
    this.loadItemData();
  },
  methods: {
    loadItemData() {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/adviser/adviser/educations/items',
        method: 'get',
        outputKey: 'allEducations',
        loadedKey: 'loadedEducations',
        errorKey: 'loadError',
      });
    },
    editEducation (education) {
      this.$bus.$emit('adviser-education-popup-show', education);
    },
    removeEducation (education) {
      if (education.id) {
        this.removeInProgress = true;

        ListUtils.removeItem(this, {
          endpointBase: '/api/adviser/adviser/educations/delete/',
          id: education.id,
          successTitle: this.$t('adviserSettingsEducationInfo.entryRemove'),
          successText: this.$t('adviserSettingsEducationInfo.entryHasBeenRemove'),
          confirmTitle: this.$t('adviserSettingsEducationInfo.areYouSureRemove'),
          confirmText: this.$t('ui.thisOperationCannotUndone'),
          errorTitle: this.$t('ui.errorOccurred'),
          errorText: this.$t('adviserSettingsEducationInfo.entryRemoveError'),
          successAction: () => {
            this.removeInProgress = false;
            this.loadItemData();
          },
          cancelAction: () => {
            this.removeInProgress = false;
          }
        });
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('adviser-education-edit', this.editEducation);
    this.$bus.$off('adviser-education-remove', this.removeEducation);
    this.$bus.$off('advisor-education-reload', this.loadItemData);
  }
}
</script>
